import React from 'react';
import { Outlet } from 'react-router-dom';
import ClientSidebar from './ClientSidebar';
import BottomNav from './BottomNav';
import ConnexionBanner from '../shared/ConnexionBanner';

export default function ClientLayout() {
  return (
    <div className="app-wrapper">
      <div style={{ display: 'none' }} className="sidebar-wrapper">
        <ClientSidebar />
      </div>
      <style>{`
        @media (min-width: 992px) {
          .sidebar-wrapper { display: block !important; }
          .bottom-nav-wrapper { display: none !important; }
        }
      `}</style>
      <main className="main-content">
        <ConnexionBanner />
        <Outlet />
      </main>
      <div className="bottom-nav-wrapper">
        <BottomNav />
      </div>
    </div>
  );
}
